"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fetcher = void 0;
const exceptions_1 = require("../../exceptions");
class Fetcher {
    headers;
    url;
    debug;
    constructor(url, debug = false) {
        this.url = url;
        this.debug = debug;
        this.headers = new Headers({
            'Content-Type': 'application/json',
        });
    }
    async get(path) {
        const options = {
            path,
            method: 'GET',
        };
        return this.request(options);
    }
    async post(path, body) {
        const options = {
            path,
            body,
            method: 'POST',
        };
        return this.request(options);
    }
    async put(path, body) {
        const options = {
            path,
            body,
            method: 'PUT',
        };
        return this.request(options);
    }
    async delete(path, body) {
        const options = {
            path,
            body,
            method: 'DELETE',
        };
        return this.request(options);
    }
    addHeader(key, value) {
        this.headers.append(key, value);
    }
    async request({ path, method, body }) {
        let debugKey = '';
        let url = `${this.url}/${path}`.replace('https://', '').replace('//', '/');
        url = `https://${url}`;
        const options = {
            method,
            headers: this.headers,
            body: body ? JSON.stringify(body) : null,
        };
        if (this.debug) {
            debugKey = `\n🍿 TMDB DEBUGGER: ${url} with params ${JSON.stringify(options)}`;
            console.time(debugKey);
        }
        const response = await fetch(url, options);
        if (this.debug) {
            console.timeEnd(debugKey);
        }
        return this.toJSON(response);
    }
    async toJSON(response) {
        if (response.ok) {
            return response.json();
        }
        const error = await response.json();
        throw new exceptions_1.TMDBResponseError(response.statusText, error.status_message || response.statusText, error.status_code || response.status);
    }
}
exports.Fetcher = Fetcher;
